import alt, { AltActions } from '../alt';

class ListingsManagementPageActions extends AltActions {
  setUsePriceRecommendations(usePriceRecommendations) {
    return usePriceRecommendations;
  }

  setShowPopups(showPopups) {
    return showPopups;
  }

  removePopup(popupId: string) {
    return popupId;
  }

  closePopup(popupId: string) {
    return popupId;
  }
}

export default alt.createActions(ListingsManagementPageActions);
